export const EmailButtonKeyAndText = {
  ARRIVAL_DETAILS_HOTEL: 'Arrival details',
  COD_COMMON: 'Confirmation of Departure',
  DEPARTURE_INSTRUCTIONS: 'Departure Instruction',
  DEPARTURE_REMINDER: 'Departure Reminder',
  WELCOME_LETTER: 'Welcome Letter',
};
